import { render, staticRenderFns } from "./DocumentosProposta.vue?vue&type=template&id=2540d648&scoped=true&"
import script from "./DocumentosProposta.vue?vue&type=script&lang=js&"
export * from "./DocumentosProposta.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosProposta.vue?vue&type=style&index=0&id=2540d648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540d648",
  null
  
)

export default component.exports